import { changeResultsSelection } from "../../searchFlightsSlice";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useTranslation } from "react-i18next";
import { DirectionTypes, FlightTypeSelect } from "../../../../types";

function SearchFlightsResultsButtonsSFO() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const loading = useAppSelector(
    (state) => state.searchFlights.results.loading
  );
  const type = useAppSelector((state) => state.searchFlights.results.type);
  const direction = useAppSelector(
    (state) => state.searchFlights.results.direction
  );
  const outboundDirect = useAppSelector(
    (state) => state.searchFlights.results.outboundDirect
  );
  const outboundConnection = useAppSelector(
    (state) => state.searchFlights.results.outboundConnection
  );
  const returnDirect = useAppSelector(
    (state) => state.searchFlights.results.returnDirect
  );
  const returnConnection = useAppSelector(
    (state) => state.searchFlights.results.returnConnection
  );
  const roundTrip = useAppSelector(
    (state) => state.searchFlights.form.roundTrip
  );
  const nonStopFlights = useAppSelector(
    (state) => state.searchFlights.form.nonStopFlights
  );

  const flightType = useAppSelector(
    (state) => state.searchFlights.form.flightType
  );

  return (
    <>
      {roundTrip && (
        <div
          id="results-direction-tabs"
          className="tabs is-toggle is-toggle-rounded is-fullwidth mb-1"
        >
          <ul role="tablist" aria-label="Results Direction">
            <li
              role="tab"
              className={
                direction === DirectionTypes.Outbound ? "is-active" : ""
              }
              style={{ width: "50%" }}
            >
              <a
                tabIndex={0}
                onClick={() => {
                  if (loading) return;
                  dispatch(
                    changeResultsSelection(type, DirectionTypes.Outbound)
                  );
                }}
              >
                <span>{t("TAB_HEADER_LABEL_OUTBOUND")}</span>
              </a>
            </li>
            <li
              role="tab"
              className={direction === DirectionTypes.Return ? "is-active" : ""}
              style={{ width: "50%" }}
            >
              <a
                tabIndex={0}
                onClick={() => {
                  if (loading) return;
                  dispatch(changeResultsSelection(type, DirectionTypes.Return));
                }}
              >
                <span>{t("TAB_HEADER_LABEL_RETURN")}</span>
              </a>
            </li>
          </ul>
        </div>
      )}
      <div
        id="results-type-tabs"
        className="tabs is-toggle is-toggle-rounded is-fullwidth mb-2"
      >
        <ul role="tablist" aria-label="Results Type">
          {(nonStopFlights ||
            flightType === FlightTypeSelect.NonStop ||
            flightType === FlightTypeSelect.All) && (
            <li
              role="tab"
              className={type === "directAirport" ? "is-active" : ""}
              style={{ width: "50%" }}
            >
              <a
                tabIndex={0}
                onClick={() => {
                  if (loading) return;
                  dispatch(changeResultsSelection("directAirport", direction));
                }}
              >
                {direction === DirectionTypes.Outbound &&
                  outboundDirect.loading && <progress className="progress" />}
                {direction === DirectionTypes.Outbound &&
                  !outboundDirect.loading && (
                    <span>
                      {t("NON_STOP")} (
                      {outboundDirect.error
                        ? "!"
                        : outboundDirect.flights.length}
                      )
                    </span>
                  )}
                {direction !== DirectionTypes.Outbound &&
                  returnDirect.loading && <progress className="progress" />}
                {direction !== DirectionTypes.Outbound &&
                  !returnDirect.loading && (
                    <span>
                      {t("DIRECT")} (
                      {returnDirect.error ? "!" : returnDirect.flights.length})
                    </span>
                  )}
              </a>
            </li>
          )}

          {(flightType === FlightTypeSelect.Connecting ||
            flightType === FlightTypeSelect.All) && (
            <li
              role="tab"
              className={
                type === "connectionAirport" ||
                flightType === FlightTypeSelect.Connecting
                  ? "is-active"
                  : ""
              }
              style={{ width: "50%" }}
            >
              <a
                tabIndex={0}
                onClick={() => {
                  if (loading) return;
                  dispatch(
                    changeResultsSelection("connectionAirport", direction)
                  );
                }}
              >
                {direction === DirectionTypes.Outbound &&
                  outboundConnection.loading && (
                    <progress className="progress" />
                  )}
                {direction === DirectionTypes.Outbound &&
                  !outboundConnection.loading && (
                    <span>
                      {t("CONNECTING")} (
                      {outboundConnection.error
                        ? "!"
                        : outboundConnection.flights.length}
                      )
                    </span>
                  )}
                {direction !== DirectionTypes.Outbound &&
                  returnConnection.loading && <progress className="progress" />}
                {direction !== DirectionTypes.Outbound &&
                  !returnConnection.loading && (
                    <span>
                      {t("CONNECTING")} (
                      {returnConnection.error
                        ? "!"
                        : returnConnection.flights.length}
                      )
                    </span>
                  )}
              </a>
            </li>
          )}
        </ul>
      </div>
    </>
  );
}

export default SearchFlightsResultsButtonsSFO;
